// i18n namespace "header" (WP-A). Spanish uses tú. Sentence case everywhere.

export const en = {
  skipToContent: "Skip to content",
  homeAriaLabel: "DuxTrans, home",
  navAriaLabel: "Main",
  navServices: "Services",
  navTeam: "Team",
  navFaq: "FAQ",
  navCareers: "Careers",
  cta: "Talk to an SAP expert",
  ctaShort: "Contact",
  menu: "Menu",
  language: "Language",
};

export const es = {
  skipToContent: "Saltar al contenido",
  homeAriaLabel: "DuxTrans, inicio",
  navAriaLabel: "Principal",
  navServices: "Servicios",
  navTeam: "Equipo",
  navFaq: "Preguntas",
  navCareers: "Vacantes",
  cta: "Habla con un experto SAP",
  ctaShort: "Contacto",
  menu: "Menú",
  language: "Idioma",
};

export const fr = {
  skipToContent: "Aller au contenu",
  homeAriaLabel: "DuxTrans, accueil",
  navAriaLabel: "Principale",
  navServices: "Services",
  navTeam: "Équipe",
  navFaq: "FAQ",
  navCareers: "Carrières",
  cta: "Parler à un expert SAP",
  ctaShort: "Contact",
  menu: "Menu",
  language: "Langue",
};

export const pt = {
  skipToContent: "Pular para o conteúdo",
  homeAriaLabel: "DuxTrans, início",
  navAriaLabel: "Principal",
  navServices: "Serviços",
  navTeam: "Equipe",
  navFaq: "Perguntas",
  navCareers: "Vagas",
  cta: "Fale com um especialista SAP",
  ctaShort: "Contato",
  menu: "Menu",
  language: "Idioma",
};
